<template>
  <div class="box_mobile-floating">
    <div class="btn_floating-group">
      <!-- S : 20220429 결제예상금액 mo 추가 -->
      <div v-if="enableTotalPrice" class="total_price mo">
        <p>결제예상금액: <em>{{ computedExpectedTotalPrice }}</em>원</p>
      </div>
      <span
        v-if="!hasOneButton"
        class="btn_box"
      ><button
        type="button"
        class="btn_square-c"
        :disabled="disabledLeft"
        @click="$emit('click-left')"
      >{{ computedTitleLeft }}</button></span>
      <span
        class="btn_box"
        :style="hasOneButton ? 'width: 100%': ''"
      ><button
        type="button"
        class="btn_square-a"
        :disabled="computedDisabledRight"
        @click="$emit('click-right');$emit('click')"
      >{{ computedTitleRight }}</button></span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'FloatingButtonGroup',
  props: {
    expectedTotalPrice: {
      type: Number,
      default: 0
    },
    title: {
      type: String,
      default: null,
    },
    titleLeft: {
      type: String,
      default: null,
    },
    titleRight: {
      type: String,
      default: null,
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    disabledLeft: {
      type: Boolean,
      default: false,
    },
    disabledRight: {
      type: Boolean,
      default: false,
    },
    enableTotalPrice: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hasOneButton() {
      if (!this.titleRight && this.title !== null) {
        return true;
      }
      return false;
    },
    computedTitleRight() {
      if (this.titleRight) {
        return this.titleRight;
      }
      return this.title;
    },
    computedTitleLeft() {
      return this.titleLeft ? this.titleLeft : 'Click me';
    },
    computedDisabledRight() {
      if (this.hasOneButton) {
        return this.disabled;
      }
      return this.disabledRight;
    },
    computedExpectedTotalPrice() {
      return this.expectedTotalPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    }
  },
  methods: {
  },
  mounted() {
    this.$store.commit("floatingButtons", true)
  },
  beforeDestroy() {
    this.$store.commit("floatingButtons", false)
  }
};
</script>
